<!--
 * @Description:
 * @version:
 * @Author: sunqian_sr
 * @Date: 2022-11-29 11:15:03
 * @LastEditors: Andy
 * @LastEditTime: 2023-01-16 20:20:44
-->
<template>
  <div class="acitons-container">
    <el-button
      v-for="action in allActions.slice(0, 3)"
      type="text"
      :key="action.key"
      :class="['action-column', 'color-' + action.key]"
      :disabled="!!action.disabled"
      @click="handleAction(action.key)"
    >
      {{ action.text }}
    </el-button>
    <el-dropdown v-if="allActions.length > 3" @command="handleAction" trigger="hover">
      <span class="el-dropdown-link" style="margin-left: 10px">
        <em class="iconfont icon-shenglvehao"></em>
        <!-- <em class="el-icon-arrow-down el-icon--right"></em> -->
      </span>
      <el-dropdown-menu>
        <el-dropdown-item
          v-for="actions in allActions.slice(3)"
          :key="actions.key"
          :command="actions.key"
          :class="['action-column', 'color-' + actions.key]"
          :disabled="!!actions.disabled"
          @click="handleAction(actions.key)"
        >
          {{ actions.text }}
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>
<script>
  import { checkPermi } from '../../../../utils/src'

  export default {
    name: 'MoreTableActions',
    props: {
      actionList: {
        type: Array,
        default: () => []
      },
      row: {
        type: Object,
        default: () => {
          return {}
        }
      },
      permisList: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        allActions: []
      }
    },
    watch: {
      actionList: {
        handler() {
          this.allActions = this.actionList.filter((v) => {
            return !v.permissions || checkPermi(v.permissions, this.permisList)
          })
        },
        deep: true,
        immediate: true
      }
    },
    methods: {
      handleAction(action) {
        this.$emit('onActionClick', {
          key: action,
          data: { ...this.row }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  ::v-deep.el-popover {
    min-width: 80px !important;
  }

  .aciton-btn-box {
    display: flex;
    flex-direction: column;

    // width: 120px;
  }

  .el-dropdown-link {
    cursor: pointer;
    color: #409eff;
  }

  .el-dropdown-menu__item {
    cursor: pointer;
    color: #409eff;
  }
</style>
<style>
  .el-button.el-button--text.is-disabled,
  .el-button.el-button--text.is-disabled:focus,
  .el-button.el-button--text.is-disabled:hover {
    color: #c0c4cc !important;
  }
</style>
